import React from 'react';
import AgendaMobileWeekView from './AgendaMobileWeekView';
import { parseLocalDate, todayStr } from './AgendaResponsiveView';

function monthWeekdayHeaders() {
  return ['L', 'M', 'M', 'J', 'V', 'S', 'D'];
}

function monthCells(allDays) {
  if (!allDays.length) return [];
  const first = parseLocalDate(allDays[0]);
  const blanks = (first.getDay() + 6) % 7;
  return [
    ...Array.from({ length: blanks }, (_, index) => ({ id: `blank-${index}`, blank: true })),
    ...allDays.map(date => ({ id: date, date })),
  ];
}

export default function AgendaMobileMonthReadOnly({
  allDays,
  selectedDate,
  volverAlDia,
  countsByDate,
  daySummary,
  onSelectDate,
  onOpenCard,
}) {
  const today = todayStr();
  return (
    <div className="agm-month-view">
      <div className="agm-month-grid" aria-label="Mes solo lectura">
        {monthWeekdayHeaders().map((day, index) => (
          <span key={`${day}-${index}`} className="agm-month-weekday">{day}</span>
        ))}
        {monthCells(allDays).map(cell => {
          if (cell.blank) return <span key={cell.id} className="agm-month-cell blank" />;
          const date = parseLocalDate(cell.date);
          const counts = countsByDate[cell.date] || {};
          return (
            <button
              key={cell.date}
              type="button"
              className={[
                'agm-month-cell',
                cell.date === selectedDate ? 'selected' : '',
                cell.date === today ? 'today' : '',
              ].filter(Boolean).join(' ')}
              onClick={() => onSelectDate(cell.date)}
            >
              <strong>{date.getDate()}</strong>
              {counts.total > 0 && <span>{counts.total}</span>}
              {counts.warnings > 0 && <i />}
            </button>
          );
        })}
      </div>

      <AgendaMobileWeekView
        selectedDate={selectedDate}
        volverAlDia={volverAlDia}
        countsByDate={countsByDate}
        daySummary={daySummary}
        onSelectDate={onSelectDate}
        onOpenCard={onOpenCard}
      />
    </div>
  );
}
